import { Component, Input, OnInit } from '@angular/core';
import { NewItem } from '../models/new-item';
import { ItemsService } from '../services/items.service';
import { CommonModule } from '@angular/common';

import { RouterLink } from '@angular/router';
import { SharedModule } from '../shared/shared.module';

@Component({
    selector: 'app-simple-card',
    templateUrl: './simple-card.component.html',
    styleUrls: ['./simple-card.component.css'],
    standalone: true,
    imports: [CommonModule, RouterLink, SharedModule]
})
export class SimpleCardComponent implements OnInit {
  @Input() item: NewItem | undefined; 
  photo : string | undefined;
  showPrice: boolean | undefined;
  
  constructor(private itemsService: ItemsService) { 
  }

  ngOnInit(): void {
    if (this.item && this.item.id) {
      if ((this.item as any).photoUrls && (this.item as any).photoUrls.length > 0) {
        this.photo = (this.item as any).photoUrls[0];
      } else {
        this.itemsService.getImages(this.item.id).subscribe(images => {
          if (images && images.length > 0) {
            this.photo = images[0];
          } else if (this.item?.user_id) {
            const photoIndex = (this.item.photos && this.item.photos.length > 0) ? this.item.photos[0] : 0;
            this.photo = `https://storage.googleapis.com/artiquary.appspot.com/items/${this.item.user_id}/${this.item.id}/${photoIndex}`;
          }
        });
      }
      this.showPrice = (this.item.price != undefined && this.item.price > 0 && this.item.selling);
    }
  }
}
